import { createContext } from 'react';
export const AccordionContext = createContext();
export const SectionContext = createContext();
